


























import { defineComponent, reactive, toRefs, ref } from '@vue/composition-api';
import HelpTooltipDialogLayout from '@/components/tooltips/HelpTooltipDialogLayout.vue';

const helpTooltipDialog = ref<any>();

const state = reactive({
  dialog: false
});

export function showOperationChangerHelpTooltipDialog() {
  return helpTooltipDialog.value?.show();
}

export default defineComponent({
  name: 'HelpTooltipDialogOperationChanger',
  components: { HelpTooltipDialogLayout },
  setup() {
    return {
      ...toRefs(state),
      helpTooltipDialog
    };
  }
});
